import { doGetQCXRequest, doPostQCXRequest } from '../../utils/api/domain/domain-api-utils';

export async function fetchOrgaosAnuentes() {
  return doGetQCXRequest(['li/lpco-sync/orgaos-anuentes']);
}

export async function fetchListaModelosOrgao(idOrgao) {
  const tenant = localStorage.getItem('tenant');
  return doGetQCXRequest([`li/lpco-sync/lista-modelos?tenant=${tenant}&codigo=${idOrgao}`]);
}

export async function fetchMetadadosModelo(modeloCode) {
  const tenant = localStorage.getItem('tenant');
  return doGetQCXRequest([`li/lpco-sync/modelos-metadados?tenant=${tenant}&codigo=${modeloCode}`]);
}

export async function fetchMetadadosFormularioNcmModelo(modeloCode, ncm) {
  const tenant = localStorage.getItem('tenant');
  return doGetQCXRequest([`li/lpco-sync/metadados-modelo-ncm?tenant=${tenant}&codigo=${modeloCode}&ncm=${ncm}`]);
}

export async function fetchAllOrgaosAnuentes() {
  return doGetQCXRequest(['li/lpco-sync/orgaos-anuentes']);
}

export async function fetchTransmissaoLpco(idFatura) {
  const tenant = localStorage.getItem('tenant');
  return doPostQCXRequest([`li/lpco/transmissao?tenant=${tenant}&fatura=${idFatura}`], null);
}

export async function fetchTransmitirLpco(idFaturaLi) {
  const tenant = localStorage.getItem('tenant');
  return doPostQCXRequest([`li/lpco/transmissao?tenant=${tenant}&fatura=${idFaturaLi}`], null);
}

export async function fetchRelatorioTransmissaoLpco(idFaturaLi) {
  const tenant = localStorage.getItem('tenant');
  return doPostQCXRequest([`li/lpco/relatorio-transmissao?tenant=${tenant}&fatura=${idFaturaLi}`], null);
}
